const scratchpayLogo = '/static/icons/scratchpayLogo.png'

type ScratchLogoProps = {
	size?: number
}

export const ScratchLogo: React.FC<ScratchLogoProps> = ({ size = 125 }) => (
	<img height={size} width={size} alt="Scratchpay" src={scratchpayLogo} />
)
